import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'keys',
})
export class KeysPipe implements PipeTransform {
  transform<T extends string | number | symbol>(
    value: Record<T, unknown> | null | undefined,
  ): T[] {
    if (!value) {
      return [];
    }

    return Object.keys(value) as T[];
  }
}
